import { render, staticRenderFns } from "./LauncherVerify.vue?vue&type=template&id=227bae3d&scoped=true"
import script from "./LauncherVerify.vue?vue&type=script&lang=js"
export * from "./LauncherVerify.vue?vue&type=script&lang=js"
import style0 from "./LauncherVerify.vue?vue&type=style&index=0&id=227bae3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227bae3d",
  null
  
)

export default component.exports